import React from 'react';

const DISCORD_URL = 'https://discord.gg/6Ft3VvHn';

const cols = {
  Product: [
    { l: 'Features', h: '#features' },
    { l: 'How It Works', h: '#how-it-works' },
    { l: 'FAQ', h: '#faq' },
  ],
  Resources: [
    { l: 'Documentation', h: '/docs/' },
    { l: 'Discord', h: DISCORD_URL, x: 1 },
    { l: 'GitHub', disabled: true },
    { l: 'Issues', disabled: true },
  ],
  Legal: [
    { l: 'Terms', h: '/terms' },
    { l: 'Privacy', h: '/privacy' },
  ],
};

export default function Footer() {
  const go = (e, h) => {
    if (!h.startsWith('#') || h === '#') return;
    e.preventDefault();
    document.querySelector(h)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer data-testid="footer" className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div>
            <span className="footer-brand">bonk<span className="nav-logo-dot">.</span></span>
            <p className="footer-tagline">Professional metadata editor for DJs. Open source.</p>
          </div>
          {Object.entries(cols).map(([title, links]) => (
            <div key={title}>
              <h4 className="footer-col-title">{title}</h4>
              {links.map((l) => (
                l.disabled ? (
                  <span
                    key={l.l}
                    className="footer-link footer-link--disabled"
                    aria-disabled="true"
                    data-testid={`footer-link-${l.l.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    {l.l}
                  </span>
                ) : (
                  <a
                    key={l.l}
                    href={l.h}
                    className="footer-link"
                    onClick={(e) => go(e, l.h)}
                    target={l.x ? '_blank' : undefined}
                    rel={l.x ? 'noopener noreferrer' : undefined}
                    data-testid={`footer-link-${l.l.toLowerCase().replace(/\s/g, '-')}`}
                  >
                    {l.l}
                  </a>
                )
              ))}
            </div>
          ))}
        </div>

        <div className="footer-bottom">
          <span className="footer-meta">2026 Bonk</span>
          <span className="footer-meta">Built for the DJ community</span>
        </div>
      </div>
    </footer>
  );
}
